import axios from "axios"
export const API_URL = process.env.REACT_APP_CORE_API;
export const URL_DASHBOARD =  process.env.REACT_APP_DASHBOARD_API;
export const URL_QONTAK =  process.env.REACT_APP_QONTAK_API;
export const TOKEN_QONTAK =  process.env.REACT_APP_TOKEN;
export const TOKEN_CHANNEL =  process.env.REACT_APP_CHANNEL;

const appHeaderProperties = {
  Accept: 'application/json',
}

export const apiCall = async ({ method, url, data = "", baseURL }, navigation) => {
  let head = {
    ...appHeaderProperties,
    ...data.headers,
  };
  try {
    const response = await axios({
      baseURL: baseURL || API_URL,
      method: method,
      url: url,
      data: data.data || "",
      headers: head || "",
      params: data.params || "",
      'axios-retry': {
        retries: 0
      }
    });
    return response.data;
  } catch (error) {
    console.log(error)
  }
};


export const apiCallQontak = async ({ method, url, data = "", baseURL }, navigation) => {
  let head = {
    ...appHeaderProperties,
    ...data.headers,
  };
  try {
    const response = await axios({
      baseURL: baseURL || URL_QONTAK,
      method: method,
      url: url,
      data: data.data || "",
      headers: head || "",
      params: data.params || "",
      'axios-retry': {
        retries: 0
      }
    });
    return response.data;
  } catch (error) {
    console.log(error)
  }
};